/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  name: "TimeLogs",
  props: ["logs"],
  data: () => {
    return {};
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("table", { staticClass: "table table-fluid table-bordered" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "tbody",
        [
          !_vm.logs || _vm.logs.length === 0
            ? _c("tr", [
                _c(
                  "td",
                  { staticClass: "text-center", attrs: { colspan: "5" } },
                  [_vm._v("No time logs yet.")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.logs, function(log, index) {
            return _c("tr", { key: log.name }, [
              _c("td", { staticClass: "text-center align-middle" }, [
                _vm._v(_vm._s(index + 1))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(log.employee))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-center align-middle" }, [
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(log.from_time || "-"))
                ]),
                _vm._v(" "),
                _vm._m(2, true),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(log.to_time || "-"))
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right align-middle" }, [
                _vm._v(_vm._s(log.time_in_mins))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right align-middle" }, [
                _vm._v(_vm._s(log.completed_qty))
              ])
            ])
          })
        ],
        2
      )
    ])
  ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("small", [_vm._v("Time Logs")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v("No.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Employee")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Working Time")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Time in Mins")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Qty")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0" }, [_c("small", [_vm._v("to")])])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/job_card_web/components/TimeLogs.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__